// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vn3q8","right":"Footer_right__2XwI0","buttons":"Footer_buttons__ZBDKc"};